__turbopack_context__.v({
  "product-footer": "ProductCardFooter-module-scss-module__r9j_CG__product-footer",
  "product-footer__cta": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__cta",
  "product-footer__disclaimer": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__disclaimer",
  "product-footer__info": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__info",
  "product-footer__rates": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__rates",
  "product-footer__rates--expanded": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__rates--expanded",
  "product-footer__rates-header": "ProductCardFooter-module-scss-module__r9j_CG__product-footer__rates-header",
  "product-rates": "ProductCardFooter-module-scss-module__r9j_CG__product-rates",
});
